import { render } from "./QuestionnairePage.vue?vue&type=template&id=781a892d&scoped=true"
import script from "./QuestionnairePage.vue?vue&type=script&lang=js"
export * from "./QuestionnairePage.vue?vue&type=script&lang=js"

import "./QuestionnairePage.vue?vue&type=style&index=0&id=781a892d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781a892d"]])

export default __exports__